import { Box, Button, Grid, GridItem, Icon, Text } from "@chakra-ui/react";
import { XIcon } from "@phosphor-icons/react/dist/ssr";
import { useDropzone } from "react-dropzone";

import { toaster } from "@/components/ui/toaster";
import { Tooltip } from "@/components/ui/tooltip";

const FileButton = ({ label, value, setValue }) => {
    const { getRootProps, getInputProps } = useDropzone({
        accept: {
            "image/png": [".png"],
            "image/jpg": [".jpg"],
            "image/jpeg": [".jpeg"],
        },
        multiple: false,
        onDrop: (acceptedFiles) => {
            const acept_files = acceptedFiles.map((file) => {
                {
                    if (file.size < 5000000) {
                        return Object.assign(file, {
                            preview: URL.createObjectURL(file),
                        });
                    } else {
                        toaster.create({
                            title: "Error!",
                            description:
                                "El documento excede 5MB, por favor intenta subir un documento que no exceda 5MB",
                            type: "error",
                            duration: 4000,
                            closable: true,
                        });
                    }
                }
            });
            if (acept_files.length > 0 && acept_files[0]) {
                let files_ad = value.concat(acept_files);
                setValue(files_ad);
            }
        },
    });

    const thumbs = value.map((file, index) => (
        <GridItem
            borderRadius="5px"
            colSpan={1}
            key={file?.name}
            textAlign="center"
            alignItems="flex-start"
            placeSelf="center"
            display="flex"
            _hover={{ backgroundColor: "#F6F6F6" }}
            bg="#F6F6F6"
            px={4}
            py={2}
        >
            <Text ml={5}>
                {file?.name?.substring(0, 15)} {file?.name?.length > 15 ? "..." : ""}
            </Text>
            <Tooltip content="Eliminar">
                <Button
                    position="absolute"
                    display="flex"
                    minW={4}
                    w={4}
                    h={4}
                    p={1}
                    bg="black"
                    rounded="full"
                    _hover={{ bg: "gray" }}
                    onClick={(e) => {
                        e.preventDefault();
                        deleteFile(index);
                    }}
                >
                    <Icon w={3} color="white">
                        <XIcon weight="bold" />
                    </Icon>
                </Button>
            </Tooltip>
        </GridItem>
    ));
    const deleteFile = (idx) => {
        let files_copy = value.filter((file, indx) => indx !== idx);
        setValue(files_copy);
    };

    return (
        <>
            <Box {...getRootProps({ className: "dropzone" })} mx="auto" textAlign="center">
                <input {...getInputProps()} />
                <Button
                    rounded="full"
                    colorPalette="brand"
                    fontSize="sm"
                    disabled={value.length === 1}
                    bg="brand.500"
                    px={4}
                >
                    {label}
                </Button>
            </Box>
            {value.length > 0 ? (
                <aside>
                    <Grid templateColumns={{ md: "repeat(4, 1fr)", base: "1fr" }} gap={4} mt={2}>
                        {thumbs}
                    </Grid>
                </aside>
            ) : null}
        </>
    );
};

export default FileButton;
